export default __webpack_public_path__ + "static/media/image-team-members.f4078f89.jpg";